import { fetchAPI } from "@/keecloak";
import { debounce } from "../util";

let lastFetchingPromise = null;

export default {
  namespaced: true,
  state: () => ({
    references: null,
    totalCount: null,
    currentOffset: 0,
    loading: true,
    loadingError: null,
    fetchParams: {
      offset: 0,
      limit: null,
      query: null,
      sortBy: null,
      sortDesc: false,
      queryLanguage: null,
      filter: {}
    },
  }),
  mutations: {
    setReferences(state, { references, totalCount }) {
      state.references = references;
      state.totalCount = totalCount;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.loadingError = error;
    },
    clearFetchParams(state) {
      state.fetchParams = {
        offset: 0,
        limit: 10,
        query: null,
        sortBy: null,
        sortDesc: false,
        queryLanguage: null,
        filter: {}
      };
    },
    setFetchParams(state, params) {
      state.fetchParams = { ...state.fetchParams, ...params };
    },
  },
  actions: {
    fetchReferences(context, args) {
      context.commit("setLoading", true);
      context.commit("setError", null);
      debouncedFetchReferences(context, args);
    },
  },
};

const debouncedFetchReferences = debounce(async (context, { append = false, ...params } = {}) => {
  const fetchParams = {...context.state.fetchParams, ...params}

  let queryParams = { include_files: true };

  if (fetchParams.sortBy != undefined)
    queryParams.sort_by =
      (fetchParams.sortDesc ? "-" : "") +
      fetchParams.sortBy;
  if (
    fetchParams.query &&
    fetchParams.query.trim().length > 0
  )
    {
      let queryKey = 'query'
      if (fetchParams.queryLanguage != null && fetchParams.queryLanguage.trim().length > 0) queryKey = queryKey + "_" + fetchParams.queryLanguage
      queryParams[queryKey] = fetchParams.query;
    }
  if (
    fetchParams.limit != undefined &&
    fetchParams.offset != undefined
  ) {
    queryParams.limit = fetchParams.limit;
    queryParams.offset = fetchParams.offset;
  }

  if (fetchParams.filter != null) {
    Object.assign(queryParams, fetchParams.filter)
  }

  try {
    const promise = fetchAPI(`references?${new URLSearchParams(queryParams)}`, {
      method: "GET",
    });

    lastFetchingPromise = promise;

    const res = await promise;

    if (!res.ok) throw new Error(await extractErrorMessage(res));

    const data = await res.json();

    if (promise != lastFetchingPromise) return;

    context.commit("setReferences", {
      references: append
        ? [...context.state.references, ...data.items]
        : data.items,
      totalCount: data.totalCount,
    });
  } catch (e) {
    console.error(e);
    context.commit("setError", e);
  } finally {
    context.commit("setLoading", false);
  }
});

async function extractErrorMessage(res) {
  const text = await res.text();
  try {
    const json = JSON.parse(text);
    return json.message || text;
  } catch (e) {
    return text;
  }
}
